import { createSlice } from "@reduxjs/toolkit";

export const ipInformation = createSlice(
    { 
        name:'information',
        initialState: {value: {}},
        reducers: {
            setIpInformation: (state, action) => {
                state.value = action.payload;
       
             },

        }
    }
);
export const {setIpInformation} =  ipInformation.actions;

export default ipInformation.reducer;